import Container from './Container';
import Link from './Link';

const ImageList = { Container, Link };

export default ImageList;
